
import React, { useState, useEffect, useCallback } from 'react';

import { FiSearch } from 'react-icons/fi';
import DataGrid from 'react-data-grid';


import { Tabela } from './styles';
import api from '../../../services/api';
import Button from '../../Button';

interface VendasPorProduto {
  cd_prod: number;
  nm_prod: string;
  vl_unit: number;
  qtd: number;
  unid: number;
  subtot: number;
  vl_desc: number;
  dt: number;
  cd: number;
  total: number;
}

interface VendasProdutosProps {
  dt_inicial: string;
  dt_final: string;
}

const defaultColumnProperties = {
  resizable: true,
}

const columnsVendaPorProduto = [
  { key: 'Produto', name: 'Produto' },
  {
    key: 'SubTotal',
    name: 'Sub Total',
    width: 100,
  },
].map((c) => ({ ...c, ...defaultColumnProperties }));

const EmptyRowsView = () => {
  const message = 'Ops, não há dados disponíveis para as datas selecionadas...';
  return (
    <div style={{ textAlign: 'center', padding: '100px' }}>
      <h3>{message}</h3>
    </div>
  );
};


const VendasPorProduto: React.FC<VendasProdutosProps> = ({ dt_inicial, dt_final }) => {
  const [rowsVendaProd, setRowsVendaProd] = useState([] as any);
  const [totalVendas, setTotalVendas] = useState('');
  const [arrayProtuto, setArrayProduto] = useState([] as any);
  const [totalVendasProduto, setTotalVendasProduto] = useState('');

  const [pesquisa, setPesquisa] = useState('');

  const cd_empresa = sessionStorage.getItem('cd');

  useEffect(() => {
    api
      .get<VendasPorProduto[]>('reports/VendasPorProduto', {
        params: {
          dt_inicial,
          dt_final,
          cd_empresa,
        },
      })
      .then((response) => {
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
        let soma = 0;
        let somaTotal = 0;
        let ArrayProduto: any[] = [];
        const itemsFormattedPorVenda = [] as Array<any>;
        response.data.forEach((vendaPorProduto) => {
          itemsFormattedPorVenda.push({
            Produto: vendaPorProduto.nm_prod,
            SubTotal: formatter.format(vendaPorProduto.subtot),
          });
          soma += vendaPorProduto.subtot;
          ArrayProduto = itemsFormattedPorVenda;
          somaTotal += vendaPorProduto.subtot;
        });
        setTotalVendas(formatter.format(soma));
        setRowsVendaProd(itemsFormattedPorVenda);
        setArrayProduto(ArrayProduto)
        setTotalVendasProduto(formatter.format(soma))
      })
      .catch(() => {
        setRowsVendaProd([]);
      });
  }, [cd_empresa, dt_final, dt_inicial, totalVendas])

  const handlePesquisa = useCallback((e) => {
    setPesquisa(e.target.value);
  }, []);
  return (
    <>
      <Tabela>
        <h1>VALOR TOTAL DE VENDAS:{totalVendasProduto || 'R$:0,00'} </h1>
        <div className="inputDiv">
          <FiSearch />
          <input
            placeholder="Pesquisar"
            onChange={handlePesquisa}
          />
        </div>
        {arrayProtuto
          .filter((prod: any) =>
            prod.Produto.toUpperCase().includes(pesquisa.toUpperCase()),
          )
          .map((filtrar: any) => (
            <Button>
              {filtrar.Produto} | {filtrar.SubTotal}
            </Button>
          ))}
      </Tabela>
      {
        arrayProtuto.length == 0 && (
          <Tabela>
            <DataGrid
              columns={columnsVendaPorProduto}
              rowGetter={(i) => rowsVendaProd[i]}
              rowsCount={rowsVendaProd.length}
              minHeight={400}
              emptyRowsView={EmptyRowsView}
            />
          </Tabela>
        )
      }
    </>
  );
};
export default VendasPorProduto;